import type { PropsWithChildren } from 'react';
import React, { createContext, useMemo } from 'react';

import type { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import type { Logger } from '@feature-hub/logger';
import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import type { AudiVideoServiceInterfaceV1 } from '@oneaudi/video-service';
import type { OneGraphServiceV1 } from '@oneaudi/onegraph-service';

interface FeatureAppEnv {
  featureAppId: string;
  featureAppName?: string;
}

export interface ContextState {
  readonly featureAppEnv: FeatureAppEnv;
  readonly localeService: LocaleServiceV1;
  readonly loggerService?: Logger;
  readonly trackingService?: TrackingServiceV2;
  readonly videoService?: AudiVideoServiceInterfaceV1;
  readonly oneGraphService: OneGraphServiceV1;
}

export const Context = createContext<ContextState>({} as ContextState);

export interface ContextProviderProps {
  readonly featureAppEnv: FeatureAppEnv;
  readonly localeService: LocaleServiceV1;
  readonly loggerService?: Logger;
  readonly trackingService?: TrackingServiceV2;
  readonly videoService?: AudiVideoServiceInterfaceV1;
  readonly oneGraphService: OneGraphServiceV1;
}

const ContextProvider = ({
  children,
  featureAppEnv,
  localeService,
  loggerService: logger,
  trackingService,
  videoService,
  oneGraphService,
}: PropsWithChildren<ContextProviderProps>) => {
  const value = useMemo(
    () => ({
      featureAppEnv,
      localeService,
      loggerService: logger,
      trackingService,
      videoService,
      oneGraphService,
    }),
    [],
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
export default ContextProvider;
